// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3HSFU","field":"Settings_field__XFv9o","label":"Settings_label__2HQ4u"};